import React from "react";
import { getBezierPath } from "reactflow";

/*
Handles the fancy curve into the middle of the node
*/

function getFromXY(fromNode, toX, toY) {
  const {
    position: { x, y },
    width,
    height,
  } = fromNode;

  if (toX >= x && toX <= x + width && toY >= y && toY <= y + height) {
    return [null, null];
  }

  const topLeft = [x + 1, y + 1];
  const topRight = [x + width - 1, y + 1];
  const bottomRight = [x + width - 1, y + height - 1];
  const bottomLeft = [x + 1, y + height - 1];
  const centerLeft = [x, y + height / 2];
  const centerRight = [x + width, y + height / 2];
  const centerTop = [x + width / 2, y];
  const centerBottom = [x + width / 2, y + height];

  const positions = [
    { name: "topLeft", value: topLeft },
    { name: "topRight", value: topRight },
    { name: "bottomRight", value: bottomRight },
    { name: "bottomLeft", value: bottomLeft },
    { name: "centerLeft", value: centerLeft },
    { name: "centerRight", value: centerRight },
    { name: "centerTop", value: centerTop },
    { name: "centerBottom", value: centerBottom },
  ];
  const distances = positions.map(({ value }) =>
    Math.hypot(value[0] - toX, value[1] - toY)
  );

  const closestIndex = distances.indexOf(Math.min(...distances));

  const [fromX, fromY] = positions[closestIndex].value;

  // if positions[closestIndex].name starts with center, if it's left or right return [fromX, toY] else return [toX, fromY]
  if (positions[closestIndex].name.startsWith("center")) {
    if (
      positions[closestIndex].name.endsWith("Left") ||
      positions[closestIndex].name.endsWith("Right")
    ) {
      return [fromX, toY];
    } else {
      return [toX, fromY];
    }
  }

  return [fromX, fromY];
}

export default ({ fromPosition, toX, toY, toPosition, fromNode }) => {
  let [fromX, fromY] = getFromXY(fromNode, toX, toY);

  if (fromX === null && fromY === null) {
    return null;
  }

  const [edgePath] = getBezierPath({
    sourceX: fromX,
    sourceY: fromY,
    sourcePosition: fromPosition,
    targetX: toX,
    targetY: toY,
    targetPosition: toPosition,
  });

  return (
    <g>
      <path
        fill="none"
        stroke="#b1b1b7"
        strokeWidth={1.5}
        className="animated"
        d={`M${fromX},${fromY} C ${fromX} ${toY} ${fromX} ${toY} ${toX},${toY}`}
      />
      <circle
        cx={toX}
        cy={toY}
        fill="#fff"
        r={3}
        stroke="#222"
        strokeWidth={1.5}
      />
    </g>
  );
};
